





















import { mapState, mapGetters } from 'vuex';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { IDInterface } from '@/domains/General';
import ItemsList from '@/components/common/ItemsList.vue';
import TournamentInterface from '@/domains/models/Tournament';
import CustomButton from '@/components/common/CustomButton.vue';
import { TOURNAMENTS_ADD_EDIT_FORM_MODAL } from '@/constants/modals';

@Component({
  components: { CustomButton, ItemsList },
  computed: {
    ...mapState('tournaments', ['selectedData', 'loadingSelectedData', 'errorMessage'])
  }
})
export default class Tournaments extends Vue {
  private selectedData!: TournamentInterface;

  private mounted() {
    this.$store.dispatch(`tournaments/fetchOne`, {
      id: this.$route.params.id
    });
  }

  private handleEditBasiDetails(e: any) {
    e.preventDefault();

    this.$store.dispatch(`modal/showModal`, {
      title: 'Update tournament basic details',
      component: TOURNAMENTS_ADD_EDIT_FORM_MODAL
    });
  }
}
